/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as AppRouteImport } from "./routes/_app"
import { Route as AppIndexRouteImport } from "./routes/_app.index"
import { Route as LoginResetRouteImport } from "./routes/login.reset"

const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRoute,
} as any)
const LoginResetRoute = LoginResetRouteImport.update({
  id: "/login/reset",
  path: "/login/reset",
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  "/login/reset": typeof LoginResetRoute
  "/": typeof AppIndexRoute
}
export interface FileRoutesByTo {
  "/login/reset": typeof LoginResetRoute
  "/": typeof AppIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_app": typeof AppRouteWithChildren
  "/login/reset": typeof LoginResetRoute
  "/_app/": typeof AppIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: "/login/reset" | "/"
  fileRoutesByTo: FileRoutesByTo
  to: "/login/reset" | "/"
  id: "__root__" | "/_app" | "/login/reset" | "/_app/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginResetRoute: typeof LoginResetRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_app": {
      id: "/_app"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/": {
      id: "/_app/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/login/reset": {
      id: "/login/reset"
      path: "/login/reset"
      fullPath: "/login/reset"
      preLoaderRoute: typeof LoginResetRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginResetRoute: LoginResetRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
